import { CardStackBlock as CardStackBlockSDS } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';

import { renderRichTextMultiLineWithMarkings } from '../../utils/renderText/renderRichText';
import { CardStackCard } from './CardStackCard';
import type { CardStackBlockDataProps } from './types';

export const CardStackBlock: FC<CardStackBlockDataProps> = props => {
  const {
    anchor,
    backgroundColor,
    cardMediaAspectRatio,
    cardsCollection,
    eyebrow,
    fullHeight,
    text,
    textAlignmentDesktop,
    textAlignmentMobile,
    title,
  } = props;

  const cards = cardsCollection.items.map(card => (
    <CardStackCard
      key={card.sys.id}
      {...card}
      aspectRatio={cardMediaAspectRatio}
      theme={backgroundColor}
    />
  ));

  return (
    <CardStackBlockSDS
      eyebrow={eyebrow}
      title={renderRichTextMultiLineWithMarkings(title)}
      text={text}
      cardMediaAspectRatio={cardMediaAspectRatio}
      backgroundColor={backgroundColor}
      textAlignmentDesktop={textAlignmentDesktop}
      textAlignmentMobile={textAlignmentMobile}
      fullHeight={fullHeight}
      anchorId={anchor}
    >
      {cards}
    </CardStackBlockSDS>
  );
};

CardStackBlock.displayName = 'CardStackBlock';
